import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'routes.PayPage.Main.mobile.MobilePaymentContainer.title',
    defaultMessage: '页面title',
    description: '备注: 页面title'
  },
  UseMyHistory: {
    id: 'components.PaymentMethods.AddNewCard.UseMyHistory',
    defaultMessage: 'Pay with saved card',
    description: '请修改',
  },
  BtnText: {
    id: 'components.PaymentMethods.AddNewCard.BtnText',
    defaultMessage: 'Proceed to pay',
    description: '请修改',
  },

  BankCard:{
    id: 'components.PaymentFormContainer.modalTitle',
    defaultMessage: 'Bank Card',
    description: 'use as the modal title'
  },
  MesagePay:{
    id: 'components.PaymentFormContainer.messagePay',
    defaultMessage: 'Message Pay',
    description: 'use as the modal title'
  }
})
